exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rtabs[data-v-6d773d48]{background:#fff;border:1px solid #e8ebef;height:100%}.rtabs .rpanel-content[data-v-6d773d48]{height:calc(100% - 43px)}.rtabs .rtabs-list[data-v-6d773d48]{border-bottom:1px solid #e8ebef;line-height:42px;height:43px;padding:0 24px}.rtabs .rtabs-list .rtab[data-v-6d773d48]{float:left;margin-right:24px;box-sizing:border-box;list-style:none;text-align:center;cursor:pointer}.rtabs .rtabs-list .t-name[data-v-6d773d48]{font-size:14px;color:#282e3d}.rtabs .rtabs-list .active[data-v-6d773d48]{display:block;width:100%;color:#2c7df1;border-bottom:2px solid #2c7df1}", ""]);

// exports
